import { useTranslate } from "@refinedev/core";
import { Modal } from "@libertify/ui";

export type AccountLockedModalProps = {
  open: boolean;
  onClose: () => void;
};

export const AccountLockedModal = ({
  open,
  onClose,
}: AccountLockedModalProps) => {
  const t = useTranslate();

  return (
    <Modal
      open={open}
      size="small"
      title={t("pages.auth.errors.accountLocked.title")}
      onClose={onClose}
      confirmText={t("pages.auth.errors.accountLocked.cta")}
      onConfirm={onClose}
    >
      <p>{t("pages.auth.errors.accountLocked.description")}</p>
    </Modal>
  );
};
